import { Alert } from "@mantine/core";
import { IconLoader2 } from "@tabler/icons-react";

type ProductGridToolbarProps = {
  /** Whether the grid currently has any products to search. */
  hasProducts: boolean;
  hasProductSet: boolean;
  isSearching: boolean;
  searchError: string | null;
  query: string;
  onQueryChange: (query: string) => void;
};

export const ProductGridToolbar = ({
  hasProducts,
  hasProductSet,
  isSearching,
  searchError,
  query,
  onQueryChange,
}: ProductGridToolbarProps) => {
  if (!hasProducts && !hasProductSet) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2 px-3">
      <div className="relative flex items-center">
        <input
          type="text"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Search products by name…"
          className="min-w-[200px] flex-1 rounded-full border border-[#E2E8F0] bg-white px-4 py-2 pr-10 text-[14px] text-[#1e293b] outline-none transition-colors focus:border-[#5A6EFA]"
        />
        {isSearching && (
          <IconLoader2
            size={16}
            stroke={2.2}
            className="absolute right-4 animate-spin text-[#5A6EFA]"
          />
        )}
      </div>
      {searchError && (
        <Alert variant="light" color="red" className="py-2">
          {searchError}
        </Alert>
      )}
    </div>
  );
};
